import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableItem, CreateTrackableItem } from 'types/trackables';

import { useAPI } from 'hooks/api/useAPI';

export interface UseCreateTrackableItemParams extends CreateTrackableItem {
  trackable_list_id: string;
}

export function useCreateTrackableItem({
  onSettled,
  ...options
}: UseMutationOptions<TrackableItem, APIError, UseCreateTrackableItemParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, ...data }: UseCreateTrackableItemParams) => {
      const response = await client.post(`/apps/${applicationID}/trackables/${trackable_list_id}/items`, data);
      return response.data;
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        // Invalidate trackable items queries
        queryClient.invalidateQueries(['trackable-items']);
      },
    }
  );
}